<template>
  <div class="image_flame">
    <draggable
      v-model="uploadImage"
      v-bind="dragOptions"
      handle=".list_num"
      :force-fallback="true"
      class="image_box"
    >
      <div
        v-for="(image, index) in uploadImage"
        :key="index"
        class="image_card"
      >
        <v-btn icon class="list_num image_drag_btn" color="black">
          <v-icon>mdi-drag</v-icon>
        </v-btn>
        <div v-show="!uploadImage[index].is_enable" class="white_back"></div>
        <v-card loading="false" outlined tile width="167">
          <v-img
            height="220px"
            :src="
              uploadImage[index].path
                ? setting.cdn + uploadImage[index].path
                : ''
            "
            v-if="uploadImage[index].path"
          >
          </v-img>
          <v-img
            height="220px"
            src="@/assets/images/no_image.jpg"
            v-else
          ></v-img>
          <div class="image_info pa-1">
            <div>
              <span>#{{ index + 1 }}</span
              ><span
                >&nbsp;{{ uploadImage[index].type }}&nbsp;<span class="mini">{{
                  uploadImage[index].width
                    ? "[W:" +
                      uploadImage[index].width +
                      "xH:" +
                      uploadImage[index].height +
                      "]"
                    : ""
                }}</span></span
              >
            </div>
          </div>
          <v-card-actions class="pa-1">
            <input
              name="upload_file"
              ref="upload"
              type="file"
              style="display: none"
              :upload_index="index"
              @change="onImageUploaded"
            />
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" icon>
                  <v-icon @click="$refs.upload[index].click()"
                    >mdi-upload
                  </v-icon>
                </v-btn>
              </template>
              <span>画像アップロード</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" icon>
                  <v-icon
                    @click="openCropDialog(index)"
                    :disabled="!uploadImage[index].path"
                    >mdi-crop
                  </v-icon>
                </v-btn>
              </template>
              <span>トリミング</span>
            </v-tooltip>
            <!-- <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" icon v-show="false">
                  <v-icon @click="onCopy($event)" :copy_index="index"
                    >mdi-content-paste</v-icon
                  >
                </v-btn>
              </template>
              <span>全媒体共通の画像をコピー</span>
            </v-tooltip> -->
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" icon>
                  <v-icon
                    @click="onMonitor(index)"
                    :disabled="!uploadImage[index].path"
                    :color="uploadImage[index].is_enable ? 'info' : ''"
                    >{{
                      uploadImage[index].is_enable
                        ? "mdi-toggle-switch"
                        : "mdi-toggle-switch-off"
                    }}</v-icon
                  >
                </v-btn>
              </template>
              <span>有効/無効</span>
            </v-tooltip>
            <v-spacer></v-spacer>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" icon>
                  <v-icon @click="onImageDelete(index)">mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>画像削除</span>
            </v-tooltip>
          </v-card-actions>
        </v-card>
      </div>
    </draggable>
    <!-- トリミングダイアログ -->
    <v-dialog
      v-model="cropDialog"
      v-if="cropDialog"
      scrollable
      persistent
      width="100%"
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <v-icon left>mdi-crop</v-icon>
          <span class="text-h5">トリミング＆リサイズ</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeCropDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <div class="v-input--checkbox v-input--dense mb-2">
            <span class="v-label">アスペクト比</span>
          </div>
          <div class="d-flex flex-wrap mb-2">
            <v-btn
              v-for="ratio in aspectRatios"
              :key="ratio.label"
              small
              class="mr-1 mb-1"
              :color="cropAspectLabel === ratio.label ? 'primary' : ''"
              :dark="cropAspectLabel === ratio.label"
              @click="setAspectRatio(ratio)"
              >{{ ratio.label }}</v-btn
            >
          </div>
          <div class="mb-2">
            青枠をドラッグしてトリミング範囲を選択してください。
          </div>
          <div class="d-flex justify-center" style="padding-top: 4px">
            <div style="max-width: 500px; width: 100%; aspect-ratio: 1/1">
              <vue-cropper
                ref="cropper"
                :src="cropImageSrc"
                :aspect-ratio="cropAspectRatio"
                :view-mode="1"
                :auto-crop-area="1"
                :background="false"
                :responsive="true"
                :center="false"
                :zoom-on-wheel="false"
                :zoom-on-touch="false"
                :toggle-drag-mode-on-dblclick="false"
                style="width: 100%; height: 100%"
                @ready="onCropperReady"
                @crop="onCrop"
              ></vue-cropper>
            </div>
          </div>
          <div class="text-center mb-2 pa-1 grey lighten-4 mx-auto" style="max-width: 500px;">
            元画像 横:{{ cropOriginalWidth }}px 縦:{{ cropOriginalHeight }}px
            形式:{{ cropOriginalType }}
          </div>
          <v-checkbox
            v-model="resizeEnabled"
            label="リサイズ"
            hide-details
            dense
            class="mb-2"
          ></v-checkbox>
          <div class="d-flex align-center flex-wrap">
            <span class="mr-1" :class="{ 'grey--text': !resizeEnabled }"
              >横:</span
            >
            <v-text-field
              v-model.number="resizeWidth"
              type="number"
              dense
              hide-details
              outlined
              :disabled="!resizeEnabled"
              style="max-width: 100px"
              class="mr-1"
              suffix="px"
              :min="1"
              @input="onResizeWidthChange"
            ></v-text-field>
            <span class="mr-1 ml-2" :class="{ 'grey--text': !resizeEnabled }"
              >縦:</span
            >
            <v-text-field
              v-model.number="resizeHeight"
              type="number"
              dense
              hide-details
              outlined
              :disabled="!resizeEnabled"
              style="max-width: 100px"
              class="mr-1"
              suffix="px"
              :min="1"
              @input="onResizeHeightChange"
            ></v-text-field>
            <v-btn
              small
              text
              color="primary"
              class="ml-2"
              :disabled="!resizeEnabled"
              @click="resetResize"
            >
              <v-icon left small>mdi-refresh</v-icon>リセット
            </v-btn>
          </div>
          <div class="mt-4">
            画像をトリミングしてもプロフィール編集画面の「保存」ボタンを押すまではシステムに保存されません。
          </div>
        </v-card-text>
        <v-card-actions>
          <v-container>
            <v-row justify="end">
              <v-col cols="6" sm="3">
                <general-button
                  btn_type="info"
                  btn_block
                  :btn_disabled="cropLoading"
                  @click-event="executeCrop"
                  ><template v-slot:icon
                    ><v-icon left>mdi-crop</v-icon></template
                  >{{
                    cropLoading ? "処理中..." : "確定"
                  }}</general-button
                >
              </v-col>
              <v-col cols="6" sm="3">
                <general-button
                  btn_color="gray"
                  btn_block
                  @click-event="closeCropDialog"
                  ><template v-slot:icon
                    ><v-icon left>mdi-close-circle</v-icon></template
                  >キャンセル</general-button
                >
              </v-col>
            </v-row>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { set, ref, reactive, toRefs } from "@vue/composition-api";
import draggable from "vuedraggable";
import VueCropper from "vue-cropperjs";
import "vue-cropperjs/node_modules/cropperjs/dist/cropper.css";
import { repositoryFactory } from "@/repository/repositoryFactory";
import store from "@/store/index.js";
import setting from "@/common/setting.js";

export default {
  components: {
    draggable,
    VueCropper,
  },
  props: ["img_num", "cast_id", "shop_site_id", "image_list"],
  setup(props, ctx) {
    const fileRepository = repositoryFactory.get("file");

    const cropper = ref(null);

    const aspectRatios = [
      { label: "フリー", value: NaN, w: 0, h: 0 },
      { label: "1:1", value: 1 / 1, w: 1, h: 1 },
      { label: "2:3", value: 2 / 3, w: 2, h: 3 },
      { label: "3:4", value: 3 / 4, w: 3, h: 4 },
      { label: "4:5", value: 4 / 5, w: 4, h: 5 },
      { label: "5:6", value: 5 / 6, w: 5, h: 6 },
      { label: "9:16", value: 9 / 16, w: 9, h: 16 },
    ];

    const detectAspectRatio = (width, height) => {
      if (!width || !height) return aspectRatios[0];
      const imageRatio = width / height;
      for (let i = 1; i < aspectRatios.length; i++) {
        const r = aspectRatios[i];
        if (Math.abs(imageRatio - r.w / r.h) < 0.005) return r;
      }
      return aspectRatios[0];
    };

    const state = reactive({
      uploadImage: [],
      // トリミング関連
      cropDialog: false,
      cropImageSrc: "",
      cropTargetIndex: null,
      cropAspectRatio: NaN,
      cropAspectLabel: "フリー",
      cropOriginalWidth: 0,
      cropOriginalHeight: 0,
      cropOriginalType: "",
      cropLoading: false,
      cropOutputWidth: 0,
      cropOutputHeight: 0,
      // リサイズ関連
      resizeEnabled: false,
      resizeWidth: 0,
      resizeHeight: 0,
      resizeEditing: false,
    });

    const onMonitor = (index) => {
      const tmp = state.uploadImage[index];
      tmp.is_enable = !tmp.is_enable;
      set(state.uploadImage, index, tmp);
    };

    const onImageDelete = (index) => {
      set(state.uploadImage, index, {
        "path": null,
        "type": null,
        "width": null,
        "height": null,
        "is_enable": true,
      });
    };

    const uploadServer = async (index, imgObj, image) => {
      // if (state.uploadImage[index].image_base64) {
      if (imgObj.src) {
        // ここで画像保存処理(サーバにアップロードする)
        let ext = image.type.substr(image.type.indexOf("/") + 1);
        if (ext == "jpeg") {
          ext = "jpg";
        }
        const d = new Date();
        // アップロード用のファイル名を生成
        const file_name =
          "_tmp_" +
          store.getters["shops/currentShop"].id +
          "_" +
          d.getTime() +
          "." +
          ext;
        const image_params = {
          shop_id: store.getters["shops/currentShop"].id,
          base64_image: imgObj.src,
          file_name: file_name,
        };
        // ファイルアップロード
        const upload_result = await fileRepository
          .upload(image_params)
          .then((response) => {
            if (response.data) {
              if (response.data.status) {
                // 画像追加OK
                set(state.uploadImage, index, {
                  "path": response.data.file_name,
                  "type": image.type.split("/")[1].toUpperCase(),
                  "width": imgObj.width,
                  "height": imgObj.height,
                  "is_enable": true,
                });
              } else {
                // 画像追加NG
                alert(response.data.message);
              }
              return response.data.status;
            }
          })
          .catch((error) => {
            throw (
              "ERROR:tabImage.vue/save fileRepository.upload (" + error + ")"
            );
          });
        if (!upload_result) return false;
      }
      return true;
    };

    const createImage = async (image, index) => {
      const reader = new FileReader();
      // imageをreaderにDataURLとしてattachする
      reader.readAsDataURL(image);
      // readAdDataURLが完了したあと実行される処理
      reader.onload = () => {
        const imgObj = new Image();
        imgObj.src = reader.result;
        imgObj.onload = () => {
          // すぐストレージにアップロードする
          uploadServer(index, imgObj, image);
        };
      };
    };

    const onImageUploaded = async (e) => {
      const files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      const type = files[0].type;
      if (
        type !== "image/jpeg" &&
        type !== "image/gif" &&
        type !== "image/webp" &&
        type !== "image/png"
      ) {
        alert(
          ".jpg、.gif、.png、.webpのいずれかのファイルのみ許可されています。[" +
            files[0].type +
            "]"
        );
        return;
      }
      // 画像を保持
      const index = e.target.getAttribute("upload_index");
      await createImage(files[0], index);
    };

    const getImageList = () => {
      return state.uploadImage;
    };

    const setImage = (img, index) => {
      set(state.uploadImage, index, img);
    };

    const init = async () => {
      state.uploadImage = props.image_list;
    };

    init();

    const openCropDialog = (index) => {
      const image = state.uploadImage[index];
      if (!image || !image.path) return;
      state.cropTargetIndex = index;
      state.cropImageSrc =
        setting.cdn + image.path + "?t=" + new Date().getTime();
      state.cropOriginalWidth = image.width || 0;
      state.cropOriginalHeight = image.height || 0;
      state.cropOriginalType = image.type || "";
      // 画像のアスペクト比に一致するボタンがあれば選択
      const matched = detectAspectRatio(image.width, image.height);
      state.cropAspectRatio = matched.value;
      state.cropAspectLabel = matched.label;
      state.cropDialog = true;
    };

    const closeCropDialog = () => {
      state.cropDialog = false;
      state.cropImageSrc = "";
      state.cropTargetIndex = null;
      state.resizeEnabled = false;
    };

    const onCropperReady = () => {
      // Cropper準備完了時の処理（必要に応じて）
    };

    const onCrop = (event) => {
      const data = event.detail || {};
      state.cropOutputWidth = Math.floor(data.width || 0);
      state.cropOutputHeight = Math.floor(data.height || 0);
      // クロップ範囲が変わったらリサイズ値をリセット
      if (!state.resizeEditing) {
        let rw = Math.round(data.width || 0);
        let rh = Math.round(data.height || 0);
        // 元画像サイズと1px以内の差ならスナップ
        if (Math.abs(rw - state.cropOriginalWidth) <= 1) rw = state.cropOriginalWidth;
        if (Math.abs(rh - state.cropOriginalHeight) <= 1) rh = state.cropOriginalHeight;
        state.resizeWidth = rw;
        state.resizeHeight = rh;
      }
    };

    const onResizeWidthChange = () => {
      if (
        !state.cropOutputWidth ||
        !state.cropOutputHeight ||
        !state.resizeWidth
      )
        return;
      state.resizeEditing = true;
      const ratio = state.cropOutputHeight / state.cropOutputWidth;
      state.resizeHeight = Math.round(state.resizeWidth * ratio);
      state.resizeEditing = false;
    };

    const onResizeHeightChange = () => {
      if (
        !state.cropOutputWidth ||
        !state.cropOutputHeight ||
        !state.resizeHeight
      )
        return;
      state.resizeEditing = true;
      const ratio = state.cropOutputWidth / state.cropOutputHeight;
      state.resizeWidth = Math.round(state.resizeHeight * ratio);
      state.resizeEditing = false;
    };

    const resetResize = () => {
      state.resizeWidth = state.cropOutputWidth;
      state.resizeHeight = state.cropOutputHeight;
    };

    const setAspectRatio = (ratio) => {
      state.cropAspectLabel = ratio.label;
      state.cropAspectRatio = ratio.value;
      if (cropper.value) {
        cropper.value.setAspectRatio(ratio.value);
      }
    };

    const executeCrop = async () => {
      if (!cropper.value || state.cropLoading) return;
      state.cropLoading = true;
      const index = state.cropTargetIndex;
      // リサイズが有効な場合は指定サイズで出力
      const useResize =
        state.resizeEnabled && state.resizeWidth > 0 && state.resizeHeight > 0;
      const canvasOptions = useResize
        ? { width: state.resizeWidth, height: state.resizeHeight }
        : {};
      let canvas = cropper.value.getCroppedCanvas(canvasOptions);

      // getCroppedCanvasが指定サイズと異なる場合、指定サイズのcanvasに描き直す
      if (
        useResize &&
        (canvas.width !== state.resizeWidth ||
          canvas.height !== state.resizeHeight)
      ) {
        const fixedCanvas = document.createElement("canvas");
        fixedCanvas.width = state.resizeWidth;
        fixedCanvas.height = state.resizeHeight;
        fixedCanvas
          .getContext("2d")
          .drawImage(canvas, 0, 0, state.resizeWidth, state.resizeHeight);
        canvas = fixedCanvas;
      }
      if (!canvas) {
        state.cropLoading = false;
        return;
      }

      // トリミング前後のサイズが同じ場合は処理不要
      if (
        canvas.width === state.cropOriginalWidth &&
        canvas.height === state.cropOriginalHeight
      ) {
        state.cropLoading = false;
        closeCropDialog();
        return;
      }

      // 元画像の拡張子を取得
      const currentImage = state.uploadImage[index];
      let ext = "jpg";
      if (currentImage.type) {
        ext = currentImage.type.toLowerCase();
        if (ext === "jpeg") ext = "jpg";
      }
      const mimeType =
        ext === "png"
          ? "image/png"
          : ext === "webp"
          ? "image/webp"
          : ext === "gif"
          ? "image/gif"
          : "image/jpeg";

      const base64 = canvas.toDataURL(mimeType);
      const d = new Date();
      const file_name =
        "_tmp_" +
        store.getters["shops/currentShop"].id +
        "_" +
        d.getTime() +
        "." +
        ext;
      const image_params = {
        shop_id: store.getters["shops/currentShop"].id,
        base64_image: base64,
        file_name: file_name,
      };

      await fileRepository
        .upload(image_params)
        .then((response) => {
          if (response.data && response.data.status) {
            set(state.uploadImage, index, {
              path: response.data.file_name,
              type: ext.toUpperCase(),
              width: canvas.width,
              height: canvas.height,
              is_enable: true,
            });
            closeCropDialog();
          } else {
            alert(
              response.data ? response.data.message : "トリミングに失敗しました"
            );
          }
        })
        .catch((error) => {
          alert("トリミング画像のアップロードに失敗しました: " + error);
        })
        .finally(() => {
          state.cropLoading = false;
        });
    };

    const onCopy = async ($event) => {
      ctx.emit("copy_click", $event);
    };

    return {
      dragOptions: {
        animation: 200,
        group: props.shop_site_id,
        disabled: false,
        ghostClass: "ghost",
      },
      setting,
      props,
      cropper,
      aspectRatios,
      ...toRefs(state),
      onMonitor,
      onImageDelete,
      onImageUploaded,
      onCopy,
      getImageList,
      setImage,
      uploadServer,
      openCropDialog,
      closeCropDialog,
      onCropperReady,
      onCrop,
      setAspectRatio,
      onResizeWidthChange,
      onResizeHeightChange,
      resetResize,
      executeCrop,
    };
  },
};
</script>

<style scoped>
/** アイコンの間隔を調整 */
.v-application--is-ltr .v-card__actions > .v-btn.v-btn + .v-btn {
  margin-left: 4px;
}
.image_flame {
  overflow: auto;
}
.image_box {
  display: flex;
}
.image_card {
  margin-right: 0.25em;
  position: relative;
}
.image_drag_btn {
  position: absolute;
  top: 3px;
  right: 3px;
  z-index: 4;
}
.image_info {
  position: absolute;
  bottom: 44px;
  right: 0px;
  z-index: 4;
  width: 100%;
  color: white;
  background-color: rgba(0, 0, 0, 0.5);
}
.white_back {
  background-color: rgba(255, 255, 255, 0.5);
  height: 220px;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
}
</style>

<style>
/* Cropper.jsのリサイズポイント */
.cropper-point {
  width: 7px !important;
  height: 7px !important;
  opacity: 0.85 !important;
  background-color: #39f !important;
}
/* Cropper.jsのクロップボックスの線を太く */
.cropper-line {
  background-color: #39f !important;
}
.cropper-line.line-n {
  height: 2px !important;
  top: -1px !important;
}
.cropper-line.line-s {
  height: 2px !important;
  bottom: -1px !important;
}
.cropper-line.line-e {
  width: 2px !important;
  right: -1px !important;
}
.cropper-line.line-w {
  width: 2px !important;
  left: -1px !important;
}
/* Cropper.jsの背景を白に統一 */
.cropper-container {
  background-color: #fff !important;
}
</style>
